import styled from "styled-components";
import theme from "../../theme/theme";

export const MainHeader = styled.h1`
  color: ${theme.color.navy};
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 5px;

  @media (max-width: 420px) {
    font-size: 2rem;
  }
`;

export const HeaderContainer = styled.div`
  margin-left: 10%;
  width: 80%;
  border-bottom: 1px solid ${theme.color.silver};
  margin-bottom: 30px;

  @media (max-width: 420px) {
    margin-left: 5%;
    width: 90%;
  }
`;

export const ReservationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px auto 20px;

  @media (max-width: 420px) {
    width: 90%;
  }

  @media (min-width: 421px) and (max-width: 768px) {
    width: 80%;
  }
`;

export const NullPage = styled.div`
  height: 80vh;
  align-items: center;
  margin-top: 20vh;
  display: flex;
  flex-direction: column;
  @media (max-width: 420px) {
    width: 90%;
  }
`;

export const NullMessage = styled.h1`
  color: ${theme.color.navy};
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0;
  text-align: center;
  @media (max-width: 420px) {
    font-size: 1.7rem;
  }
`;

export const NullDescription = styled.p`
  color: ${theme.color.stone};
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 5px;
  text-align: center;
`;
